import { authorizedApi } from './index';

export const stripeApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    createOnrampSession: builder.mutation({
      query: ({ destinationNetwork, destinationAmount }) => ({
        url: `/stripe/onramp`,
        method: 'POST',
        body: {
          destinationNetwork,
          destinationAmount,
        },
      }),
    }),
  }),
});

export const { useCreateOnrampSessionMutation } = stripeApi;
